module.exports = __webpack_public_path__ + "3fc4fd8a2657d18fb1dc6dbd77eb317d.png";